import EventsKeywordFilter from './EventsKeywordFilter';
import PrimaryViewToggle from './PrimaryViewToggle';

const Messaging = window.tnew.ui.messaging;

class EventListingPrimaryView {
  constructor(config, keywordFilter, viewToggle) {
    this.keywordFilter = keywordFilter;
    this.config = config;
    this.isVisible = false;

    this.keywordFilter.on(EventsKeywordFilter.UPDATE, this.onKeywordFilterUpdate.bind(this));

    viewToggle.on(PrimaryViewToggle.UPDATE, this.onPrimaryViewModeUpdate.bind(this));
  }

  onPrimaryViewModeUpdate({ mode }) {
    this.isVisible = this.constructor.ViewMode === mode;

    if (this.isVisible) {
      this.fetchData();
    }
  }

  onKeywordFilterUpdate() {
    if (this.isVisible) {
      this.fetchData();
    }
  }

  async fetchData() {
    const view = this.getCurrentView();
    const keywords = this.keywordFilter.getSelectedKeywords();
    const messageCategory = 'event-listing';
    let data;

    Messaging.clear(messageCategory);

    try {
      data = await this.store.fetchData(view.getRangeForSelectedDate(), keywords);
    } catch (exception) {
      Messaging.clear(messageCategory);
      Messaging.addError('An unexpected error has occured.', true, messageCategory);
      return;
    }

    if (data) {
      view.setData(data);
    } else {
      // console.warn('fetch result ignored');
    }
  }
}

export default EventListingPrimaryView;



// WEBPACK FOOTER //
// ./V7/events/listing/EventListingPrimaryView.js